import React from 'react';
import Main from './components/Main'

import './App.css';
import './animations.css';
import './icons.css'

import AuthGuard from './components/AuthGuard';
import { StaffStatusProvider } from './contexts/StaffStatusContext'
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import toast from 'react-hot-toast';


// Create a client
const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      toast.error(`Error: ${error.message}`, {
        duration: Infinity,
        id: 'queryError'
      })
    },
    onSettled: () => {
      toast.dismiss('queryLoading');
    },
    onSuccess: () => {
      toast.dismiss('queryError');
    },
  })
});

const App: React.FC = () => { 
  return (
    <QueryClientProvider client={queryClient}>
      <AuthGuard>
        <StaffStatusProvider>
          <Main />
        </StaffStatusProvider>
      </AuthGuard>
    </QueryClientProvider>
  )
};

// Export the component with React Query provider
export default App;